import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import CustomCardWithHeader from "../../../../../../components/custom-card-with-header/CustomCardWithHeader";
import { Col, Row, Table } from "antd";
import { assessmentIcons } from "../../../../../utils/assessmentIcons";
import CustomCard from "../../../../../../dentail-indetifcation/components/d-reusable/CustomCard";
import { useLocation } from "react-router-dom";
import { getProjectDetailsAsPdf } from "../../../../../../components/https/age-assessment-apis";
import { errorRequestHandel } from "../../../../../../helper";

const estimation_report = [
  { title: "Registration Date", value: "12/02/2024" },
  { title: "Full Name/Nationality", value: "John / UAE" },
  { title: "Identity Type/Code", value: "Unknown/Unknown" },
  { title: "Receipt’s Name", value: "Dr Salem" },
  { title: "Case Number", value: "AE-20081007-MLE-0358AM" },
  { title: "Stated Age", value: "15 Jun 1969 | 39 y , 3m , 22d" },
  { title: "Ethnicity", value: "European, Latino Descent" },
  { title: "Purpose of Assessment ", value: "Research & Development" },
];

const resultsData = [
  {
    key: "1",
    tooth_position: "ISO 22",
    tooth_name: "Lower Right 1st Premolar",
    t: "92.1",
    cp: "9",
    cl: "29.2",
    pulp_area: "1213",
    tooth_area: "12430",
    mean: "43y, 2m",
    standard_deviation: "+/- 7.35",
    range: "35y, 11m to 50y, 7m",
  },
  {
    key: "2",
    tooth_position: "ISO 22",
    tooth_name: "Lower Right 1st Premolar",
    t: "92.1",
    cp: "9",
    cl: "29.2",
    pulp_area: "1213",
    tooth_area: "12430",
    mean: "43y, 2m",
    standard_deviation: "+/- 7.35",
    range: "35y, 11m to 50y, 7m",
  },
  {
    key: "3",
    tooth_position: "ISO 22",
    tooth_name: "Lower Right 1st Premolar",
    t: "92.1",
    cp: "9",
    cl: "29.2",
    pulp_area: "1213",
    tooth_area: "12430",
    mean: "43y, 2m",
    standard_deviation: "+/- 7.35",
    range: "35y, 11m to 50y, 7m",
  },
];

const ShortPdfReport = () => {
  const scrollRef = useRef(null);
  const location = useLocation();
  const [data, setData] = useState("");
  const projectId = location.state?.projectId; // Get caseId from state

  useEffect(() => {
    scrollRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [location]);

  useEffect(() => {
    getPdfReport();
  }, []);

  const getPdfReport = async () => {
    try {
      const response = await getProjectDetailsAsPdf({ id: projectId });
      if (response.status === 200) {
        setData(response.data.html);
      }
    } catch (error) {
      errorRequestHandel({ error: error });
    }
  };
  return (
    <div
      className="short_report_container case_details_container"
      ref={scrollRef}
    >
      <div
        className="short_report_body"
        // dangerouslySetInnerHTML={{ __html: data }}
      >
        <CustomCardWithHeader title={"Age Estimation Report"} isCenter={true}>
          <Row gutter={(16, 16)}>
            {estimation_report.map((item, index) => {
              return (
                <Col md={6} key={index}>
                  <div className="estimation_report">
                    <p className="_key">{item.title}</p>
                    <p className="_value">{item.value}</p>
                  </div>
                </Col>
              );
            })}
          </Row>
        </CustomCardWithHeader>

        <CustomCardWithHeader title={"Results"} isCenter={true}>
          <div className="result_section">
            <div className="title">
              <p>Cameriere Method</p>
            </div>
            <div className="result_table">
              <div className="_table_header">
                <p>Teeth</p>
                <p>Measurement</p>
                <p>Conclusion</p>
              </div>
              <Table
                dataSource={resultsData}
                style={{ overflowX: "scroll" }}
                pagination={false}
                columns={[
                  {
                    title: "Tooth Position",
                    dataIndex: "tooth_position",
                    key: "tooth_position",
                  },
                  {
                    title: "Tooth Name",
                    dataIndex: "tooth_name",
                    key: "tooth_name",
                  },
                  {
                    title: "Pulp Area",
                    key: "pulp_area",
                    dataIndex: "pulp_area",
                  },
                  {
                    title: "Tooth Area",
                    key: "tooth_area",
                    dataIndex: "tooth_area",
                  },
                  {
                    title: "Mean",
                    key: "mean",
                    dataIndex: "mean",
                  },

                  {
                    title: "Deviation",
                    key: "standard_deviation",
                    dataIndex: "standard_deviation",
                  },
                  {
                    title: "Range",
                    key: "range",
                    dataIndex: "range",
                  },
                ]}
              />
            </div>
          </div>
          <div className="result_section">
            <div className="title">
              <p>
                Kvaal Method <img src={assessmentIcons.caseStar} />
              </p>
            </div>
            <div className="result_table">
              <div className="_table_header">
                <p>Teeth</p>
                <p>Measurement</p>
                <p>Conclusion</p>
              </div>
              <Table
                dataSource={resultsData}
                style={{ overflowX: "scroll" }}
                pagination={false}
                columns={[
                  {
                    title: "Tooth Position",
                    dataIndex: "tooth_position",
                    key: "tooth_position",
                  },
                  {
                    title: "Tooth Name",
                    dataIndex: "tooth_name",
                    key: "tooth_name",
                  },
                  {
                    title: "T",
                    key: "t",
                    dataIndex: "t",
                  },
                  {
                    title: "P",
                    key: "t",
                    dataIndex: "t",
                  },
                  {
                    title: "R",
                    key: "t",
                    dataIndex: "t",
                  },
                  {
                    title: "A",
                    key: "t",
                    dataIndex: "t",
                  },
                  {
                    title: "B",
                    key: "t",
                    dataIndex: "t",
                  },
                  {
                    title: "C",
                    key: "t",
                    dataIndex: "t",
                  },
                  {
                    title: "C'",
                    key: "t",
                    dataIndex: "t",
                  },
                  {
                    title: "Mean",
                    key: "mean",
                    dataIndex: "mean",
                  },

                  {
                    title: "Deviation",
                    key: "standard_deviation",
                    dataIndex: "standard_deviation",
                  },
                  {
                    title: "Range",
                    key: "range",
                    dataIndex: "range",
                  },
                ]}
              />
            </div>
          </div>
          <div className="result_section">
            <div className="title">
              <p>Ikeda Method</p>
            </div>
            <div className="result_table">
              <div className="_table_header">
                <p>Teeth</p>
                <p>Measurement</p>
                <p>Conclusion</p>
              </div>
              <Table
                dataSource={resultsData}
                style={{ overflowX: "scroll" }}
                pagination={false}
                columns={[
                  {
                    title: "Tooth Position",
                    dataIndex: "tooth_position",
                    key: "tooth_position",
                  },
                  {
                    title: "Tooth Name",
                    dataIndex: "tooth_name",
                    key: "tooth_name",
                  },
                  {
                    title: "CP",
                    key: "cp",
                    dataIndex: "cp",
                  },
                  {
                    title: "CL",
                    key: "cl",
                    dataIndex: "cl",
                  },
                  {
                    title: "Mean",
                    key: "mean",
                    dataIndex: "mean",
                  },

                  {
                    title: "Deviation",
                    key: "standard_deviation",
                    dataIndex: "standard_deviation",
                  },
                  {
                    title: "Range",
                    key: "range",
                    dataIndex: "range",
                  },
                ]}
              />
            </div>
          </div>
        </CustomCardWithHeader>

        <CustomCardWithHeader title={"Conclusion"} isCenter={false}>
          <div className="case_details_result_info">
            <Row gutter={[16, 16]}>
              <Col md={8}>
                <div className="case_details_result_details">
                  <p>Biological Age</p>
                  <span>42y, 7m</span>
                </div>
              </Col>
              <Col md={8}>
                <div
                  className="case_details_result_details"
                  style={{ borderLeftColor: "#F5B46B" }}
                >
                  <p>Biological DOB</p>
                  <span>14 Feb 1966</span>
                </div>
              </Col>
              <Col md={8}>
                <div
                  className="case_details_result_details"
                  style={{ borderLeftColor: "#DF2D2E" }}
                >
                  <p>Biological Range</p>
                  <span>31y, 11m to 53y, 3m</span>
                </div>
              </Col>
            </Row>
            <div className="conclutions_information">
              <p>
                The stated age falls within the range affirmed by the age
                assessment; it should be recognized as the person's official
                age.
              </p>
            </div>
          </div>
        </CustomCardWithHeader>

        <CustomCardWithHeader title={"Signatures"} isCenter={false}>
          <div className="signatures_report">
            <Row gutter={[16, 16]}>
              <Col md={12}>
                <p className="_heading">Examiner</p>
                <Row>
                  <Col md={12}>
                    <p className="_key">Full Name</p>
                    <p className="_value">Dr. Salem</p>
                  </Col>
                  <Col md={12}>
                    <p className="_key">License Number</p>
                    <p className="_value">License - 101</p>
                  </Col>
                </Row>
              </Col>
              <Col md={12}>
                <p className="_heading">Reviwer</p>
                <Row>
                  <Col md={12}>
                    <p className="_key">Full Name</p>
                    <p className="_value">Salem Saeed</p>
                  </Col>
                  <Col md={12}>
                    <p className="_key">License Number</p>
                    <p className="_value">GP 6116326</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </CustomCardWithHeader>
      </div>
    </div>
  );
};

export default ShortPdfReport;
